import axios from 'axios';
import NetworkErrorWindow from '~/foundation/networkError';
import {
    SUCCESS_STATUS_CODE,
    NO_USER_TOKEN_STATUS_CODE_GATEWAY,
    NO_USER_TOKEN_STATUS_CODE_SERVER,
    REQUEST_METHOD_GET,
    REQUEST_METHOD_POST
} from '@/common/const';
import main from './procedure/main';

const defaultConfig = {
    // baseURL: 'http://mktop.ppdapi.com',
    headers: {
        'Content-Type': 'application/json;charset=UTF-8'
    },
    module: '',
    timeout: 10000,
    validateStatus: () => {
        return true;
    },
    withCredentials: true,
    transformRequest: [
        function(data) {
            return JSON.stringify(data);
        }
    ]
};

function Service() {
    // this.needToken = needToken
    let services = [...main];
    let _this = this;
    let _http = axios.create(defaultConfig);

    // 添加请求拦截器
    _http.interceptors.request.use(
        config => {
            return config;
        },
        error => {
            // 对请求错误做些什么
            console && console.log({ error });
            Promise.reject(error);
        }
    );

    _http.interceptors.response.use(
        response => {
            let { data: res, status: httpStatus, config } = response;
            let { url } = config;
            if (httpStatus === SUCCESS_STATUS_CODE) {
                // http status 为 200，表示正确响应
                let { result: code } = res;
                if (code === -1) {
                    return Promise.reject(res);
                } else {
                    return Promise.resolve(res);
                }
            } // eslint-disable-line
            else if (
                httpStatus === NO_USER_TOKEN_STATUS_CODE_GATEWAY ||
                httpStatus === NO_USER_TOKEN_STATUS_CODE_SERVER
            ) {
                let configItem = services.find(e => {
                    return e.subUrl === url;
                });
                let needToken = configItem && configItem['needToken'];
                if (needToken) {
                    // 判断是否为借款app
                    if (window.PPDWebUI.os.inApp) {
                        let param = {
                            url: window.location.href
                        };
                        window.sessionStorage.setItem('go2Login', true);
                        window.PPDWebUI.AccountService.auth(param);
                    } else {
                        let params = window.location.href;
                        window.location.href =
                            'https://account.ppdai.com/h5/login?returnUrl=' +
                            encodeURIComponent(params);
                    }
                }
                // 没有登录态
                return Promise.reject(res);
            } else {
                // 其他http status 的处理
                return Promise.reject(res);
            }
        },
        // 服务器出现问题，无法给予正确的响应
        error => {
            console && console.log({ error });
            // NetworkErrorWindow.open();
        }
    );
    services.forEach(item => {
        let { subUrl, name, method } = item;
        _this[name] = params => {
            if (method === REQUEST_METHOD_GET) {
                return _http.get(subUrl, { params } || {});
            }
            if (method === REQUEST_METHOD_POST) {
                return _http.post(subUrl, params || {});
            }
        };
    });
}

export default new Service();
